import type { ReactNode } from 'react'
import { StearsBackdrop } from '../components/StearsBackdrop'
import { PortalBrandBar } from '../components/StearsLogo'

/**
 * The shell every standalone portal screen shares: the stears.co hero backdrop and the
 * brand bar. Landing, "no request open", the post-submission status page and the broken
 * link page all sit on it, so a company sees the same Stears surface whichever state its
 * link resolves to.
 *
 * Screens are wrapped here rather than each reaching for StearsBackdrop itself: the
 * status and no-request pages were originally built on a flat panel and looked like a
 * different product. Adding a screen means using this component, and it is dressed.
 *
 * The form itself is deliberately excluded. It is a working surface of 182 fields at
 * 12px, and the artwork competes with the labels.
 */
export function PortalPage({ children }: { children: ReactNode }) {
  return (
    <StearsBackdrop>
      <PortalBrandBar />
      {children}
    </StearsBackdrop>
  )
}
